import type { QuestionnaireResponsesQuery } from '../Questionnaire/types';

export const DASHBOARD_KPI_SUMMARY = () => 'dashboard/kpi-summary';
export const DASHBOARD_THROUGHPUT_TREND = () => 'dashboard/throughput-trend';
export const DASHBOARD_STOCK_BY_COMPOUND = () => 'dashboard/stock-by-compound';
export const DASHBOARD_STOCK_BY_MODEL = () => 'dashboard/stock-by-model';
export const DASHBOARD_STOCK_BY_STATUS = () => 'dashboard/stock-by-status';
export const DASHBOARD_LOAD_PULLING_OVERVIEW = () =>
  'dashboard/load-pulling-overview';
export const DASHBOARD_EVENT_HEATMAP = () => 'dashboard/event-heatmap';
export const DASHBOARD_LOAD_PULLING_SUMMARY = (
  siteId: number,
  customerId?: number,
) =>
  `dashboard/load-pulling-summary?siteId=${siteId}${
    customerId != null ? `&customerId=${customerId}` : ''
  }`;
export const DASHBOARD_MAINTENANCE = () => 'dashboard/maintenance';

export const BILL_OF_LADING = (movementId: number) =>
  `order/${movementId}/billOfLading`;
export const COMPANIES = () => 'companies';
export const COMPANY_TYPES = () => 'companyTypes';
export const COUNTRIES = () => 'countries';
export const DOCUMENT_MANAGEMENT_DOCUMENT_TYPES = () =>
  'DocumentManagement/documentType';
export const DOCUMENT_MANAGEMENT_DOCUMENT_TYPE = (documentTypeId: number) =>
  `DocumentManagement/documentType/${documentTypeId}`;
export const DOCUMENT_MANAGEMENT_DOCUMENTS = () =>
  'DocumentManagement/document';
export const DOCUMENT_MANAGEMENT_DOCUMENT = (documentId: number) =>
  `DocumentManagement/document/${documentId}`;
export const FUNCTIONAL_FEATURES = () => 'functionalFeatures';
export const INSPECTION_STATUS = () => 'InspectionStatus';
export const INSPECTION_STATUS_ACCESS_RULES = () =>
  'InspectionStatus/access-rules';
export const EMAIL_NOTIFICATION_ROLE_ACCESS = () =>
  'EmailNotificationRoleAccess';
export const EMAIL_NOTIFICATION_WORKFLOWS = () =>
  'EmailNotificationRoleAccess/workflows';
export const RELEASE_NOTES = () => 'ReleaseNotes';
export const RELEASE_NOTE = (id: number) => `ReleaseNotes/${id}`;
export const RELEASE_NOTES_LATEST = () => 'ReleaseNotes/latest';
export const RELEASE_NOTES_HISTORY = (skip: number, take: number) =>
  `ReleaseNotes/history?skip=${skip}&take=${take}`;
export const RELEASE_NOTES_DISMISS = () => 'ReleaseNotes/dismiss';
export const STOCK_RECONCILIATION = () => 'StockReconciliation';
export const STOCK_RECONCILIATION_COMPARE = () => 'StockReconciliation/compare';
export const STOCK_RECONCILIATION_UPLOADS = () => 'StockReconciliation/uploads';
export const STOCK_RECONCILIATION_UPLOAD_ROWS = (id: number) =>
  `StockReconciliation/${id}/rows`;
export const STOCK_RECONCILIATION_UPLOAD_COMPLETE = (id: number) =>
  `StockReconciliation/${id}/complete`;
export const STOCK_RECONCILIATION_UPLOAD_FAIL = (id: number) =>
  `StockReconciliation/${id}/fail`;
export const STOCK_RECONCILIATION_QUEUE = () => 'StockReconciliation/queue';
export const STOCK_RECONCILIATION_RUN = (id: number) =>
  `StockReconciliation/${id}`;
export const STOCK_RECONCILIATION_ROWS = (id: number) =>
  `StockReconciliation/${id}/rows`;
export const USER_EMAIL_NOTIFICATION_PREFERENCES = () =>
  'user/emailNotificationPreferences';
export const INSPECTIONS_REPORTS_INITIAL = (inspectionId: number) =>
  `Inspections/reports/initial?inspectionId=${inspectionId}`;
export const INSPECTIONS_VEHICLES = () => 'Inspections/vehicles';
export const EXPORTS_INSPECTIONS = () => 'Exports/inspections';
export const EXPORT_JOB = (exportId: string) => `Exports/${exportId}`;
export const INSPECTIONS_VEHICLES_FILTERS = () =>
  'Inspections/vehicles/filters';
export const INSPECTIONS_VEHICLES_INSIGHTS = () =>
  'Inspections/vehicles/insights';
export const INSPECTIONS_VEHICLE = (id: number) => `Inspections/vehicles/${id}`;
export const MECHANICAL_INSPECTION = (id: number, barCode: string | number) =>
  `MechanicalInspection/${id}/${barCode}`;
export const MECHANICAL_INSPECTION_AVAILABLE = (
  id: number,
  barCode: string | number,
) => `MechanicalInspection/${id}/${barCode}/available`;
export const INSPECTIONS_VEHICLE_DAMAGE_AUTHORIZATION = () =>
  `Inspections/vehicles/damages/authorization`;
export const INSPECTIONS_VEHICLE_DAMAGE_PRE_TIMING_REVIEW = () =>
  `Inspections/vehicles/damages/pre-timing-review`;
export const INSPECTIONS_VEHICLE_WORK_CENTRE = (inspectionId: number) =>
  `Inspections/vehicles/work-centre/${inspectionId}`;
export const INSPECTIONS_VEHICLE_DAMAGE_STATUS = () =>
  `Inspections/vehicles/damages/status`;
export const INSPECTIONS_VEHICLE_DAMAGE_APPROVE = () =>
  `Inspections/vehicles/damages/approve`;
export const INSPECTIONS_VEHICLES_ID_DAMAGES_LINES = (id: number) =>
  `Inspections/vehicles/${id}/damages/lines`;
export const INSPECTIONS_VEHICLE_DAMAGE_CLASSIFICATION_CHANGE_SUMMARY = (
  id: number,
) => `Inspections/${id}/vehicles/damages/classification-change-summary`;

export const GET_DAMAGES_LINES = () => `Inspections/vehicles/damages/lines`;
export const BATCH_UPDATE_DAMAGES_LINES = () =>
  `Inspections/vehicles/damages/lines`;
export const DELETE_DAMAGES_LINES = (
  damageLineId: number,
  inspectionId: number,
) => `Inspections/vehicles/damages/lines/${damageLineId}/${inspectionId}`;
export const UN_DELETE_DAMAGES_LINES = (
  damageLineId: number,
  inspectionId: number,
) =>
  `Inspections/vehicles/damages/lines/undelete/${damageLineId}/${inspectionId}`;

export const INSPECTIONS_VEHICLE_DAMAGE_PARTS = (id?: number) =>
  `Inspections/vehicles/damages/parts${id ? `/${id}` : ''}`;

export const DELETE_DAMAGE_PART = (
  partNumberId: number,
  inspectionId: number,
) => `Inspections/vehicles/damages/parts/${partNumberId}/${inspectionId}`;

export const INSPECTIONS_VEHICLE_DAMAGE_ACTIONS = () =>
  'Inspections/vehicles/damages/actions';
export const INSPECTIONS_PRE_TIME_SUGGESTIONS = (inspectionId: number) =>
  `Inspections/vehicles/${inspectionId}/damages/pre-time-suggestions`;
export const INSPECTIONS_VEHICLE_DAMAGES_CODES_SITE_PART = (
  id: number,
  siteId: string | number,
) => `Inspections/vehicles/damages/codes/${id}/${siteId}`;
export const INSPECTIONS_VEHICLE_DAMAGES_CONDITION_CODES_PART = (
  id: number,
  partCode: string | number,
) => `Inspections/vehicles/damages/condition/codes/${id}/${partCode}`;
export const INSPECTIONS_VEHICLE_SEVERITY_CODES_PART_TYPE = (
  id: number,
  partCode: string | number,
  typeCode: string | number,
) => `Inspections/vehicles/severity/codes/${id}/${partCode}/${typeCode}`;
export const INSPECTIONS_VEHICLE_REPAIR_ACTION_PART_TYPE_SEVERITY = (
  id: number,
  partCode: string | number,
  typeCode: string | number,
  severityId: number,
) =>
  `Inspections/vehicles/repair/actions/${id}/${partCode}/${typeCode}/${severityId}`;
export const INSPECTIONS_VEHICLES_PARTS = () => `Inspections/vehicles/parts`;
export const INSPECTIONS_FLAT_RATE_CODE = () => `/Inspections/vehicles/rates`;
export const INSPECTIONS_LABOUR_CODE = () => `/Inspections/vehicles/labour`;
export const INSPECTIONS_SUPPLIER_CODE = () => `/Inspections/vehicles/supplier`;
export const INSPECTIONS_SUPPLIER_PART_CODES = () =>
  `/Inspections/vehicles/supplier/parts`;

export const DELETE_DAMAGE_ACTION = (damageActionId: number) =>
  `Inspections/vehicles/damages/actions/${damageActionId}`;

export const INSPECTIONS_VEHICLES_ID_NOTES = (id: number) =>
  `Inspections/vehicles/${id}/notes`;
export const INSPECTIONS_VEHICLES_SUMMARIES = (id: number) =>
  `Inspections/vehicles/${id}/summaries`;
export const INSPECTIONS_VEHICLES_NOTES = () => `Inspections/vehicles/notes`;
export const INSPECTIONS_VEHICLES_MECHANICALS_NOTES = (id: number) =>
  `Inspections/mechanicals/${id}/notes`;
export const INSPECTIONS_MECHANICALS_WHEELS = (id: number) =>
  `Inspections/mechanicals/${id}/wheels`;
export const INSPECTIONS_LOGS = (id: number) => `Inspections/logs/${id}`;
export const INSPECTIONS_MOT = (id: number) => `Inspections/MOT/${id}`;
export const INSPECTIONS_CHECKLIST_DYNAMIC_OPERATIONS = (id: number) =>
  `Inspections/${id}/checklist/ista`;
export const INSPECTIONS_CHECKLIST_ELECTRIC_HYBRID = (id: number) =>
  `Inspections/${id}/checklist/electric`;
export const INSPECTIONS_CHECKLIST_ENGINE_RUNNING = (id: number) =>
  `Inspections/${id}/checklist/enginerunning`;
export const INSPECTIONS_CHECKLIST_INTERIOR = (id: number) =>
  `Inspections/${id}/checklist/interior`;
export const INSPECTION_DAMAGES_IMAGES = (id?: number) =>
  id ? `Inspections/damages/${id}/images` : 'Inspections/damages/images';
export const INSPECTION_DAMAGES_IMAGES_ID = (id: number) =>
  `Inspections/damages/images/${id}`;
export const INSPECTION_TNROVERRIDE = () => `Inspections/TNROverride`;
export const INSPECTION_UPDATE_TNR_PRE_APPRAISAL = () =>
  `Inspections/updateTNRPreAppraisal`;
export const INSPECTION_UPDATE_TNR_POST_APPRAISAL = () =>
  `Inspections/updateTNRPostAppraisal`;
export const INSPECTION_UPDATE_MECHANICALINSPECTION = () =>
  `Inspections/updateMechanicalInspection`;
export const INSPECTION_GETTNRDETAILS = (id: number) =>
  `Inspections/TNROverride/${id}`;
export const INSPECTION_REPLACE_IMAGE = () => `Inspections/replaceImage`;
export const INSPECTION_UPDATE_MILEAGE = () => `Inspections/mileage`;
export const INSPECTION_UPDATE_REG = () => `Inspections/replaceReg`;
export const FPR_INSPECTIONS = (vin: string) => `FprInspection/fprs/${vin}`;
export const LOCATIONS = () => 'locations';
export const LOCATIONS_SITES = (inspectionId: number) =>
  `Locations/sites/${inspectionId}`;
export const LOCATION_AW = (siteId: number) => `Locations/aw/${siteId}`;
export const LOCATION_TYPES = () => 'locationTypes';
export const ORDER_SUMMARY = () => 'order/summary';
export const PASSPORT = () => `passports`;
export const PASSPORT_JOBS = () => `passports/jobs`;
export const PASSPORTS_TRANSACTIONS = () => `passports/transactions`;
export const PASSPORTS_ARRIVALS = () => `passports/arrivals`;
export const PIPELINES_LOCATIONS = () => 'pipelines/locations';
export const PIPELINES_GRAPH = () => 'pipelines/graph';
export const PIPELINES_STATUS = (locationId?: string) =>
  locationId ? `pipelines/status?locationId=${locationId}` : 'pipelines/status';
export const PIPELINES = (locationId?: string) =>
  locationId ? `pipelines?locationId=${locationId}` : 'pipelines';
export const PTS = () => 'pts';
export const ROLES = () => 'roles';
export const SERVICE_PROVIDERS = () => 'serviceProviders';
export const SERVICE_UNITS = () => 'serviceUnits';
export const SERVICE_UNIT_TYPES = () => 'serviceUnitTypes';
export const STORAGE = () => 'storage';
export const STORAGE_GRAPH = () => 'storage/graph';
export const STORAGE_VEHICLES = () => 'storage/vehicles';
export const STORAGE_VEHICLES_FILTERS = () => 'storage/vehicles/filters';
export const STORAGE_CHECKOUT_VEHICLES = (vin: string) =>
  `storage/checkout/${vin}`;
export const SHIPPING_PLAN = (documentId?: number) =>
  documentId ? `shippingPlan/${documentId}` : 'shippingPlan';
export const SHIPPING_PLANS = (customerId?: string) =>
  customerId ? `shippingPlan/${customerId}` : 'shippingPlan';
export const CUSTOMERS = (customerId?: number) =>
  customerId ? `customers/${customerId}` : 'customers';
export const CUSTOMER_HIERARCHY = () => 'customers/hierarchy';
export const CUSTOMER_SITE_AND_INSPECTORS = () => 'customers/inspectors';
export const CUSTOMER_INSPECTOR = () => 'customers/inspector';
export const APP_FEATURES = () => 'appFeature';
export const APP_DATA_RULES = () => 'appFeature/dataRules';
export const TRANSPORT_MOVEMENTS = () => 'transport/movements';
export const LOAD_DETAILS_BY_LOADID = (id: number) =>
  `transport/movements/${id}`;
export const LOAD_LOGS_BY_LOADID = (id: number) =>
  `transport/movements/logs/${id}`;
export const TRANSPORT_POSITIONS = () => 'transport/positions';
export const USERS = (userId?: number) => (userId ? `user/${userId}` : 'user');
export const USER_TYPES = () => `user/userTypes`;
export const USER_PERMISSIONS = () => 'user/permissions';
export const RESET_PASSWORD = () => 'user/resetPassword';
export const RESET_USER_PASSWORD = () => 'user/resetUserPassword';
export const USER_LOGOUT = () => 'user/logout';
export const VESSEL_MOVEMENTS = () => 'vessel/movements';
export const VESSEL_POSITIONS = () => 'vessel/positions';
export const VESSEL_MANIFEST = () => 'vessel/manifest';
export const VIN_MOVEMENTS = () => 'vin/movements';
export const VIN_POSITIONS = (vin?: string) =>
  vin ? `vin/positions?vin=${vin}` : 'vin/positions';

export const JOB_CHAINS = (jobChainId?: number) =>
  `job${jobChainId ? `/${jobChainId}` : ''}`;
export const JOBS = () => 'job/list';
export const JOB_EXPORT = () => 'job/export';
export const JOB_CHAIN_FILTERS = () => 'job/filters';
export const JOB_CHAIN_DAG = (jobChainId: number) =>
  `job-chains/${jobChainId}/dag`;
export const CREATE_JOB = () => `job/new`;
export const CREATE_LOAD_PULL_REQUEST_JOB = () => `job/loadPullRequest`;
export const UPDATE_JOB_STATUS = () => 'job/status';
export const UPDATE_JOB_ITEM_STATUS = () => 'job/jobItem/status';
export const JOB_TYPES = () => 'job/jobTypes';
export const JOB_STATUS = () => 'job/jobStatus';
export const JOB_TAG = (id?: number) => `job/jobTag${id ? `/${id}` : ''}`;
export const JOB_TEMPLATE = (id?: number) =>
  `job/template${id ? `/${id}` : ''}`;
export const JOB_CHAIN_TEMPLATES = () => 'job-chain-templates';
export const JOB_CHAIN_TEMPLATES_METADATA = () =>
  'job-chain-templates/metadata';

export const DAMAGE_EXCEPTION = (id?: number) =>
  `damages/exception${id ? `/${id}` : ''}`;
export const DAMAGE_EXCEPTION_FILTERS = () => 'damages/exception/filters';
export const DAMAGE_EXCEPTION_NOTE = () => 'damages/exception/note';
export const DAMAGE_EXCEPTION_ACTION = () => 'damages/exception/action';
export const DAMAGE_EXCEPTION_ATTACHMENT = () => 'damages/exception/attachment';
export const DAMAGE_EXCEPTION_STATUS = () => 'damages/exception/status';
export const DAMAGES_REROUTE = () => 'damages/reroute';

export const Load_Lanes = (siteId: number, customerId: number) =>
  `LoadLanes?siteId=${siteId}&customerId=${customerId}`;

export const LOAD_LANES_ASSIGN = () => 'LoadLanes/assign';
export const LOAD_LANES_UNASSIGN = () => 'LoadLanes/unassign';
export const LOAD_LANES_MOVEMENT = () => 'LoadLanes/movement';

export const COMMAND_CENTRE_SITES = () => 'CommandCentre/sites';
export const COMMAND_CENTRE_CONFIG = () => 'CommandCentre/config';
export const COMMAND_CENTRE_POSITIONS = (siteId: number) =>
  `CommandCentre/sites/${siteId}/positions`;
export const COMMAND_CENTRE_OPERATORS = (siteId: number) =>
  `CommandCentre/sites/${siteId}/operators`;
export const COMMAND_CENTRE_EVENTS = (siteId: number) =>
  `CommandCentre/sites/${siteId}/events`;
export const COMMAND_CENTRE_CAMERAS = (siteId: number) =>
  `CommandCentre/sites/${siteId}/cameras`;
export const COMMAND_CENTRE_CAMERA_STREAM = (cameraId: number) =>
  `CommandCentre/cameras/${cameraId}/stream`;
export const COMMAND_CENTRE_OPERATOR = (userId: number) =>
  `CommandCentre/operators/${userId}`;
export const COMMAND_CENTRE_ASSIGNABLE_JOBS = (siteId: number) =>
  `CommandCentre/sites/${siteId}/assignable-jobs`;
export const COMMAND_CENTRE_ASSIGN_JOB = (userId: number) =>
  `CommandCentre/operators/${userId}/jobs`;

export const COMMS_SESSION = () => 'comms/session';
export const COMMS_DIRECT_ROOMS = () => 'comms/rooms/direct';
export const COMMS_LIVEKIT_TOKEN = () => 'comms/livekit-token';

export const QUESTIONNAIRE_TEMPLATES = () => 'questionnaire/templates';
export const QUESTIONNAIRE_TEMPLATE_DETAIL = (id: number) =>
  `questionnaire/templates/${id}`;
export const QUESTIONNAIRE_TEMPLATE_PUBLISH = (id: number) =>
  `questionnaire/templates/${id}/publish`;
export const QUESTIONNAIRE_TEMPLATE = () => 'questionnaire/template';
export const QUESTIONNAIRE_RESPONSE_SUBMIT = () =>
  'questionnaire/response/submit';
export const QUESTIONNAIRE_RESPONSE = (responseId: number) =>
  `questionnaire/response/${responseId}`;
export const QUESTIONNAIRE_RESPONSES = (query: QuestionnaireResponsesQuery) => {
  const params: string[] = [];
  if (query.customerIds && query.customerIds.length > 0) {
    params.push(
      `customerIds=${encodeURIComponent(query.customerIds.join(','))}`,
    );
  }
  if (query.templateKey) {
    params.push(`templateKey=${encodeURIComponent(query.templateKey)}`);
  }
  if (query.vin) {
    params.push(`vin=${encodeURIComponent(query.vin)}`);
  }
  if (query.sortField) {
    params.push(`sortField=${encodeURIComponent(query.sortField)}`);
  }
  if (query.sortOrder) {
    params.push(`sortOrder=${encodeURIComponent(query.sortOrder)}`);
  }
  params.push(`pageNumber=${query.pageNumber}`);
  params.push(`pageSize=${query.pageSize}`);
  return `questionnaire/responses?${params.join('&')}`;
};
